var map = {
	"./9th-pawn.jpg": 27,
	"./Chevron.svg": 28,
	"./an-awesome-wave.jpg": 29,
	"./body-music.jpg": 30,
	"./broken-bells.jpg": 31,
	"./brothers.jpg": 32,
	"./caravelle.jpg": 33,
	"./carry-and-lowell.jpg": 34,
	"./case-lang-veirs.jpg": 35,
	"./cleopatra.jpg": 36,
	"./collision-cource.jpg": 37,
	"./cupid-deluxe.jpg": 38,
	"./d-a-m-n.jpg": 39,
	"./declaration-of-independence.jpg": 40,
	"./evil-friends.jpg": 41,
	"./expectations.jpg": 42,
	"./fools.jpg": 43,
	"./for-ever.jpg": 44,
	"./good-america.jpg": 45,
	"./good-kid-maad-city.jpg": 46,
	"./heads-up.jpg": 47,
	"./here.jpg": 48,
	"./i-i.jpg": 49,
	"./in-a-tidal-wave.jpg": 50,
	"./inner-speaker.jpg": 51,
	"./jungle.jpg": 52,
	"./lonerism.jpg": 53,
	"./maggot-brain.jpg": 54,
	"./mondo.jpg": 55,
	"./multi-love.jpg": 56,
	"./negro-swam.jpg": 57,
	"./ok-computer.jpg": 58,
	"./once.jpg": 59,
	"./oracular-spetacular.jpg": 60,
	"./parcels.jpg": 61,
	"./quiet-is-new-loud.jpg": 62,
	"./riot-on-an-empty-street.jpg": 63,
	"./rules.jpg": 64,
	"./salad-days.jpg": 65,
	"./sex-and-food.jpg": 66,
	"./silk-rhodes.jpg": 67,
	"./sonate-pacifique.jpg": 68,
	"./tell-me-im-pretty.jpg": 69,
	"./the-english-riviera.jpg": 70,
	"./the-queen-is-dead.jpg": 71,
	"./the-suburbs.jpg": 72,
	"./turn-blue.jpg": 73,
	"./wilder-mind.jpg": 74,
	"./wish-you-were-here.jpg": 75,
	"./woodstock.jpg": 76
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 26;